import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './app/app';
import './styles.scss';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '../../../localization/i18n';
import { Toaster } from './components';
import { DeviceProvider } from './context/device';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const queryClient: QueryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, staleTime: 5 * 60 * 100, retry: 0 },
    mutations: { retry: 0 },
  },
});

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
          <DeviceProvider>
            <App />
          </DeviceProvider>
      </BrowserRouter>
    </QueryClientProvider>
    <Toaster />
  </StrictMode>
);
